module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-13.0ae8d74a.svg";